module.exports = __webpack_public_path__ + "e570b8a51d547d3ee3fd262c9b4cb244.ttf";